<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 종료여부 -->
          <c-select
            :comboItems="endFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="endFlag"
            label="LBL0010306"
            v-model="searchParam.endFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!-- 부서별 무재해현황 -->
    <c-table
      ref="table"
      title="LBL0010307"
      tableId="table"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="openPop" />
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'uninjury-manage',
  data() {
    return {
      searchParam: {
        plantCd: null,
        endFlag: 'N',
      },
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      endFlagItems: [
        { code: 'N', codeName: '진행중' },
        { code: 'Y', codeName: '종료' },
      ],
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            // 사업장
            label: 'LBLPLANT',
            style: 'width:220px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'deptName',
            field: 'deptName',
            // 부서
            label: 'LBLDEPT',
            align: 'center',
            sortable: true,
            type: 'link',
          },
          {
            name: 'startDt',
            field: 'startDt',
            // 무재해 시작일
            label: 'LBL0010308',
            style: 'width:200px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'dateCnt',
            field: 'dateCnt',
            // 무재해일수(진행일)
            label: 'LBL0010309',
            align: 'right',
            type: 'cost',
            style: 'width:160px',
            sortable: true,
          },
          {
            name: 'targetDt',
            field: 'targetDt',
            // 무재해 목표달성일
            label: 'LBL0010310',
            style: 'width:160px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'dateTotalCnt',
            field: 'dateTotalCnt',
            // 무재해일수(목표일)
            label: 'LBL0010311',
            align: 'right',
            style: 'width:160px',
            type: 'cost',
            sortable: true,
          },
          {
            name: 'endFlagName',
            field: 'endFlagName',
            // 종료여부
            label: 'LBL0010312',
            align: 'center',
            style: 'width:250px',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      headerUrl: '',
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sai.uninjury.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.openPop(row);
    },
    openPop(row) {
      this.popupOptions.title = 'LBL0010313';   //부서별 무재해 현황 상세
      this.popupOptions.param = {
        saiDeptUninjuryId: row ? row.saiDeptUninjuryId : '',
      };
      this.popupOptions.target = () => import(`${"./uninjuryDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = '70%';
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
